module.exports = __webpack_public_path__ + "img/zizhi12.550fd7d6.jpg";